<div class="external-exit-modal__overlay" *ngIf="open" (click)="onStay()">
  <section
    class="external-exit-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="external-exit-title"
    aria-describedby="external-exit-description"
    (click)="$event.stopPropagation()"
  >
    <h2 id="external-exit-title" class="external-exit-modal__title">
      Sair do Hub de Soluções?
    </h2>

    <p id="external-exit-description" class="external-exit-modal__description">
      Ao sair agora, você será redirecionado para a página inicial da Claro Empresas.
      Se houver produtos no carrinho, a compra não será finalizada e os itens serão removidos.
    </p>

    <div class="external-exit-modal__actions">
      <button type="button" class="external-exit-modal__button external-exit-modal__button--secondary" (click)="onExit()">
        Sair
      </button>
      <button type="button" class="external-exit-modal__button external-exit-modal__button--primary" (click)="onStay()">
        Continuar no Hub
      </button>
    </div>
  </section>
</div>
